var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "49px",
    height: "144px",
    viewBox: "0 0 49 144",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "alert") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.90964018,0.479999954 L40.0809576,0.479999954 C44.8526973,0.479999954 48.7209567,4.34825934 48.7209567,9.11999912 C48.7209567,9.50739243 48.6949023,9.89434718 48.6429699,10.2782438 L36.5654267,99.5582352 C35.9857527,103.84332 32.3275297,107.03999 28.0034144,107.03999 L22.188809,107.03999 C17.871977,107.03999 14.2175664,103.853789 13.6293857,99.5772151 L1.35021684,10.2972237 C0.700053638,5.56998477 4.00517658,1.21073899 8.73241555,0.560575787 C9.12252904,0.506921332 9.51585428,0.479999954 9.90964018,0.479999954 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-Copy-2",
    transform: "translate(-701.000000, -420.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alert",
    transform: "translate(700.550001, 420.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(13.070375, 119.476126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5867722,23.7265939 C6.30172834,23.8598686 1.09751051,18.8734413 0.962610423,12.5867722 C0.829335638,6.30172834 5.81576297,1.09751051 12.1024321,0.962610423 C18.3874759,0.829335638 23.5916938,5.81576297 23.7265939,12.1024321 C23.8614939,18.3891012 18.8734413,23.5933191 12.5867722,23.7265939 Z",
    id: "Fill-15",
    fill: "#30AADE",
    transform: "translate(12.344633, 12.344602) rotate(1.000000) translate(-12.344633, -12.344602) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9754966,22.3556589 C9.69045275,22.4889337 4.48623492,17.5025064 4.35133484,11.2158373 C17.6746412,22.3260003 26.9804182,4.44482805 27.1153183,10.7314972 C27.2502184,17.0181663 22.2621657,22.2223841 15.9754966,22.3556589 Z",
    id: "Fill-15",
    fill: "#0C83B5",
    transform: "translate(15.734663, 15.855081) rotate(-44.000000) translate(-15.734663, -15.855081) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13669032,13.8023413 C2.69623341,13.8023413 2.33379101,13.4496507 2.32403919,13.0075685 C2.25090059,9.66107117 3.25371208,6.88342961 5.22195312,4.97532476 C7.16906522,3.08509823 9.94020557,2.18143018 13.2184402,2.35046161 C13.6670237,2.37484115 14.0099624,2.75678718 13.9872082,3.2053706 C13.9628287,3.65232872 13.5906344,3.99039159 13.1322992,3.97413857 C10.3172757,3.81973485 7.96871394,4.5755004 6.35316349,6.14229178 C4.71810942,7.72858678 3.88595466,10.090151 3.94934145,12.9718119 C3.95909326,13.4203953 3.60315207,13.7925895 3.15456865,13.8023413 L3.13669032,13.8023413 Z",
    id: "Fill-17",
    fill: "#FFFFFF",
    opacity: 0.360699608,
    transform: "translate(8.154292, 8.066392) rotate(1.000000) translate(-8.154292, -8.066392) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#30AADE",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9965962,0 L51.4117283,0 L35.5533163,108.870253 L14.6557821,108.870253 C24.2658702,88.4008745 30.3918612,70.0307885 33.0337552,53.7599948 C35.6756492,37.4892012 36.9965962,19.5692029 36.9965962,0 Z",
    fill: "#0C83B5",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.55923965,11.5916558 C3.52900903,11.4200239 2.85613393,7.35351785 5.25800547,4.53816944 C6.72077741,2.82575108 8.95589295,1.97441781 11.8941142,2.01927615 C12.4333894,2.0270776 12.8634444,2.46980991 12.855643,3.00908517 C12.8478415,3.54738524 12.3875559,3.97353947 11.8668091,3.96963875 C9.55367908,3.92965631 7.81688119,4.55182198 6.74905767,5.79615331 C4.94009637,7.90547046 5.4754709,11.226938 5.48132198,11.2610693 C5.57006348,11.7905927 5.21412231,12.2947615 4.68362368,12.3844782 C4.62803835,12.39423 4.57245302,12.3991059 4.51784286,12.3991059 C4.05268139,12.3991059 3.64115488,12.0655939 3.55923965,11.5916558 Z",
    id: "Fill-6",
    fill: "#FFFFFF",
    opacity: 0.366508121,
    transform: "translate(8.152892, 7.208349) rotate(1.000000) translate(-8.152892, -7.208349) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6011295,4.05015617 C15.0706308,4.05015617 14.6357,3.62400194 14.6259482,3.09155295 C14.6171715,2.55325288 15.0462513,2.1085702 15.5845514,2.09979357 L18.6710002,2.04713378 C19.1780945,2.01885352 19.6530078,2.46743692 19.6627596,3.005737 C19.6715362,3.54403707 19.2424564,3.98871974 18.7041563,3.99749638 L15.6186827,4.05015617 L15.6011295,4.05015617 Z",
    id: "Fill-8",
    fill: "#FFFFFF",
    opacity: 0.366508121,
    transform: "translate(17.144354, 3.048011) rotate(1.000000) translate(-17.144354, -3.048011) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.da105851076b3fbde8e4dd11fbe6a036.svg";
export { ForwardRef as ReactComponent };